import { Icon } from "Components/UI/Icon";
import i18n from "i18n";
import { PanelTypeEnum } from "Data/interfaces/Panels/IPanelsResponse";
import {
  INewPanelsOptions,
  ISrcTypeOption,
  PanelsOptionsIconsType,
} from "Data/interfaces/Panels/IPanelComponentsModels";

import docs from "Static/icons/docs.png";
import sheets from "Static/icons/sheets.png";
import slides from "Static/icons/slides.png";
import calendar from "Static/icons/calendar.png";
import drive from "Static/icons/drive.png";
import maps from "Static/icons/maps.png";
import youtube from "Static/icons/youtube.png";
import onedrive from "Static/icons/onedrive.png";
import dropbox from "Static/icons/dropbox.png";
import miro from "Static/icons/miro.png";
import loom from "Static/icons/loom.png";

export const panelsOptionsIcons: PanelsOptionsIconsType = {
  '0': <Icon icon="coordly" customSize={12} className="leftCoordlyIconOptionRow" />,
  '1': <Icon icon="customTag" className="leftIconOptionRowCustom" />,
  '2': <img src={docs} alt="Google Docs" className="leftIconOptionRow" />,
  '3': <img src={sheets} alt="Google Sheets" className="leftIconOptionRow" />,
  '4': <img src={slides} alt="Google Slides" className="leftIconOptionRow" />,
  '5': <img src={calendar} alt="Google Calendar" className="leftIconOptionRow" />,
  '6': <img src={drive} alt="Google Drive" className="leftIconOptionRow" />,
  '7': <img src={maps} alt="Google Maps" className="leftIconOptionRow" />,
  '8': <img src={youtube} alt="YouTube" className="leftIconOptionRow" />,
  '9': <img src={onedrive} alt="OneDrive" className="leftIconOptionRow" />,
  '10': <img src={dropbox} alt="DropBox" className="leftIconOptionRow" />,
  '11': <img src={miro} alt="Miro" className="leftIconOptionRow" />,
  '12': <img src={loom} alt="Loom" className="leftIconOptionRow" />,
}

export const getCoordlyOption = (): INewPanelsOptions => ({
  id: PanelTypeEnum.InternalItem,
  label: i18n.t('panels:editModal.options.coordlyFile'),
  type: PanelTypeEnum.InternalItem,
  title: i18n.t('panels:editModal.details.coordlyFileTitleFull'),
  description: i18n.t('panels:editModal.details.coordlyFileDescFull'),
});

export const getPanelsOptions = (): INewPanelsOptions[] => [
  {
    id: PanelTypeEnum.Custom,
    label: i18n.t('panels:editModal.options.custom'),
    type: PanelTypeEnum.Custom,
    title: i18n.t('panels:editModal.details.customTitleFull'),
    description: i18n.t('panels:editModal.details.customDescFull'),
  },
  {
    id: PanelTypeEnum.GoogleDocs,
    label: i18n.t('panels:editModal.options.googleDocs'),
    type: PanelTypeEnum.GoogleDocs,
    title: i18n.t('panels:editModal.details.googleDocsTitle'),
    description: i18n.t('panels:editModal.details.googleDocsDesc'),
  },
  {
    id: PanelTypeEnum.GoogleSheets,
    label: i18n.t('panels:editModal.options.googleSheets'),
    type: PanelTypeEnum.GoogleSheets,
    title: i18n.t('panels:editModal.details.googleSheetsTitle'),
    description: i18n.t('panels:editModal.details.googleSheetsDesc'),
  },
  {
    id: PanelTypeEnum.GoogleSlides,
    label: i18n.t('panels:editModal.options.googleSlides'),
    type: PanelTypeEnum.GoogleSlides,
    title: i18n.t('panels:editModal.details.googleSlidesTitle'),
    description: i18n.t('panels:editModal.details.googleSlidesDesc'),
  },
  {
    id: PanelTypeEnum.GoogleCalendar,
    label: i18n.t('panels:editModal.options.googleCalendar'),
    type: PanelTypeEnum.GoogleCalendar,
    title: i18n.t('panels:editModal.details.googleCalendarTitle'),
    description: i18n.t('panels:editModal.details.googleCalendarDesc'),
  },
  {
    id: PanelTypeEnum.GoogleDrive,
    label: i18n.t('panels:editModal.options.googleDrive'),
    type: PanelTypeEnum.GoogleDrive,
    title: i18n.t('panels:editModal.details.googleDriveTitle'),
    description: i18n.t('panels:editModal.details.googleDriveDesc'),
  },
  {
    id: PanelTypeEnum.GoogleMaps,
    label: i18n.t('panels:editModal.options.googleMaps'),
    type: PanelTypeEnum.GoogleMaps,
    title: i18n.t('panels:editModal.details.googleMapsTitle'),
    description: i18n.t('panels:editModal.details.googleMapsDesc'),
  },
  {
    id: PanelTypeEnum.Youtube,
    label: i18n.t('panels:editModal.options.youtube'),
    type: PanelTypeEnum.Youtube,
    title: i18n.t('panels:editModal.details.youtubeTitle'),
    description: i18n.t('panels:editModal.details.youtubeDesc'),
  },
  {
    id: PanelTypeEnum.OneDrive,
    label: i18n.t('panels:editModal.options.oneDrive'),
    type: PanelTypeEnum.OneDrive,
    title: i18n.t('panels:editModal.details.oneDriveTitle'),
    description: i18n.t('panels:editModal.details.oneDriveDesc'),
  },
  {
    id: PanelTypeEnum.Dropbox,
    label: i18n.t('panels:editModal.options.dropbox'),
    type: PanelTypeEnum.Dropbox,
    title: i18n.t('panels:editModal.details.dropboxTitle'),
    description: i18n.t('panels:editModal.details.dropboxDesc'),
  },
  {
    id: PanelTypeEnum.Miro,
    label: i18n.t('panels:editModal.options.miro'),
    type: PanelTypeEnum.Miro,
    title: i18n.t('panels:editModal.details.miroTitle'),
    description: i18n.t('panels:editModal.details.miroDesc'),
  },
  {
    id: PanelTypeEnum.Loom,
    label: i18n.t('panels:editModal.options.loom'),
    type: PanelTypeEnum.Loom,
    title: i18n.t('panels:editModal.details.loomTitle'),
    description: i18n.t('panels:editModal.details.loomDesc'),
  },
];

export const getSrcTypeOptions = (): ISrcTypeOption[] => [
  {
    id: 'url',
    label: i18n.t('panels:editModal.options.integrateUrl'),
    icon: <Icon icon="link" customSize={12} className="rightIconSrcOption" />,
  },
  {
    id: 'html',
    label: i18n.t('panels:editModal.options.integrateHtml'),
    icon: <Icon icon="customTag" customSize={16} className="rightIconSrcOption" />,
  },
];

// Backwards-compatible exports — call the getters once at module load.
// Components that need live language switching should call the getters directly.
export const coordlyOption = getCoordlyOption();
export const panelsOptions = getPanelsOptions();
export const srcTypeOptions = getSrcTypeOptions();
